const productQuiz = document.querySelector( '.product-quiz' );
if( productQuiz ) {
  const quizForm = productQuiz.querySelector( '.quiz-form' );
  const productTypeRadios = productQuiz.querySelectorAll( '.product-type input[type=radio]' );
  const toeStyleFieldset = productQuiz.querySelector( '.toe-style' );

  productTypeRadios.forEach( ( radio ) => {
    radio.addEventListener( 'click', ( event ) => {
      if( radio.dataset.noToeStyle ) {
        toeStyleFieldset.classList.remove( 'active' );
      } else {
        toeStyleFieldset.classList.add( 'active' );
      }
    });
  });

  quizForm.addEventListener( 'submit', ( event ) => {
    event.preventDefault();
    let radios = productQuiz.querySelectorAll( '.filter-options.active input[type=radio]' );
    let quizParams = new URLSearchParams();
    radios.forEach( ( radio ) => {
      if( radio.checked ) {
        quizParams.set( radio.name, radio.value );
      }
    });
    // let genderRadio = quizForm.querySelector( 'input[name="gender"]:checked' );
    let path = "all";
    // if(genderRadio) {
    //   path = genderRadio.value;
    // }
    window.location = "http://www.ameswalker.com/collections/" + path + "/?" + quizParams.toString().replace(/%2B/g, "+").replace(/%252F/g, "%2F");
  });
}